import { atom } from "recoil";

export const addStateOfficeOrigin = atom({
  key: "addStateOfficeOrigin",
  default: false,
});
export const editStateOfficeOrigin = atom({
  key: "editStateOfficeOrigin",
  default: false,
});
export const disableButtonStateOfficeOrigin = atom({
  key: "disableButtonStateOfficeOrigin",
  default: false,
});

export const selectedRowsStateOfficeOrigin = atom({
  key: "selectedRowsStateOfficeOrigin",
  default: [],
});

export const setFilterTextOfficeOrigin = atom({
  key: "setFilterTextOfficeOrigin",
  default: "",
});
